const activity = {
  activity: "Aktivität", // translated
  activities: "Aktivitäten", // translated
  dates: "Termine", // translated
  location: "Standort", // translated
  languages: "Sprachen", // translated
  categories: "Kategorien", // translated
  ticketOption: "Ticketoption", // translated
  numberOfRatings: "Anzahl der Bewertungen", // translated
  meetingPointInfo: "Informationen zum Treffpunkt", // translated
  meetingPoint: "Treffpunkt", // translated
  meetingPoints: "Treffpunkte", // translated
  providedBy: "Zur Verfügung gestellt von", // translated
  expirationDate: "Verfallsdatum", // translated
  groupSize: "Gruppengröße", // translated
  features: "Merkmale", // translated
  basedOn: "Bezogen auf", // translated
  reviewsFromVerCustomers: "Bewertungen von verifizierten Kunden", // translated
  excellent: "exzellent", // translated
  great: "Großartig", // translated
  average: "Durchschnitt", // translated
  poor: "arm", // translated
  bad: "schlecht", // translated
  onlyBookedCustomersTooltip: "Nur Kunden, die diese Aktivität gebucht haben, können eine Bewertung abgeben", // translated
  noReviewsYet: "Im Moment gibt es keine Bewertungen für diese Aktivität.", // translated
  backToActivitiesList: "Zurück zur Aktivitätenliste", // translated
  getPrices: "erhalten Sie Preise", // translated
  availabilityAndPrices: "Verfügbarkeit und Preise", // translated
  ticketOptions: "Ticketoptionen", // translated
  ticketInfo: "Ticketinformation", // translated
  selectYourTickets: "Wählen Sie Ihre Tickets aus", // translated
  product: "Produkt", // translated
  total: "Gesamt", // translated
  slot: "Slot", // translated
  language: "Sprache", // translated
  tickets: "Tickets", // translated
  ticketsFor: "Tickets für", // translated
  previousStep: "Vorheriger Schritt", // translated
  onlyAvailableInEnglish: "Nur auf Englisch verfügbar", // translated
  guest: "Gast", // translated
  leadGuest: "Hauptgast", // translated
  adult: "Erwachsene", // translated
  child: "Kind", // translated
  pleaseSelectAdult: "Bitte wählen Sie mindestens einen Erwachsenen aus", // translated
  notAvailableActivity: "Dieses Produkt ist nicht verfügbar", // translated
  required: "Erforderlich", // translated
  pickupPoint: "Abholpunkt", // translated
  pickupPoints: "Abholpunkte", // translated
  ticketType: "Art des Tickets", // translated
  anonymous: "Anonym", // translated
  printedVoucher: "Gedruckter Gutschein wird akzeptiert", // translated
  mobileVoucher: "Mobiler Gutschein akzeptiert", // translated
  mixedVoucher: "Mobiler oder gedruckter Gutschein wird akzeptiert", // translated
  safetyMeasures: "Sicherheitsmaßnahmen angewendet", // translated
  doThisBecause: "Tun Sie dies, weil", // translated
  safetyInfo: "Sicherheitsinformationen", // translated
  reviewsHighestFirst: "Anzahl der Bewertungen (höchste zuerst)", // translated
  bookingFee: "Buchungsgebühr", // translated
  startDate: "Startdatum", // translated
  endDate: "Endtermin", // translated
  cancellationDeadlineAndFees: "Stornierungsfrist und Gebühren", // translated
  resetTickets: "Tickets zurücksetzen", // translated
  instantConfirmation: "sofortige Bestätigung", // translated
  clickResetBtn: "Klicken Sie auf die Schaltfläche „Zurücksetzen“, um Ihre Auswahl erneut zu starten", // translated
};

export default activity;
